// Do not raise error and notify error to Sentry if navigation has been redirected
export const redirectWithoutNavigationGuardError = (redirectFn, redirectPayload) => {
  // See https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
  try {
    redirectFn(redirectPayload)
  }
  catch(_err) { // eslint-disable-line no-unused-vars
    // intentionally not handled error
  }
}
